import { useMutation, useQueryClient } from 'react-query';

import type { TVendorCodesInternetHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import type { TUpdateModel } from '../../../utils/hookUtils';
import QUERYKEYS from '../../../constants/queryKeys';
import { updateVendorCodeInternetHomeWarranty } from './../../../services/VendorCodesService';

const useUpdateVendorCodeInternetHomeWarranty =
  (): TUpdateModel<TVendorCodesInternetHomeWarranty> => {
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation(updateVendorCodeInternetHomeWarranty, {
      onSuccess: () =>
        queryClient.invalidateQueries({
          predicate: (query) =>
            query.queryKey === QUERYKEYS.VENDOR_CODES ||
            query.queryKey[0] === QUERYKEYS.VENDORS ||
            query.queryKey[0] === QUERYKEYS.VENDOR_CODES_INTERNET_HOME_WARRANTY,
        }),
    });

    return {
      update: mutate,
      isLoading,
    };
  };

export default useUpdateVendorCodeInternetHomeWarranty;
